import { useEffect, useState } from "react";

// Otis Admin PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Grid from "@mui/material/Grid";
import BookingCard from "examples/Cards/BookingCard";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
// Images
import DefaultDoughnutChart from "examples/Charts/DoughnutCharts/DefaultDoughnutChart";
import PieChart from "examples/Charts/PieChart";


function LandingLayout() {
  const navigate = useNavigate();



  return (
    <DashboardLayout>
    </DashboardLayout>
  );
}

export default LandingLayout;